import ImageComponent from '@components/common/ImageComponent/ImageComponent';
import ivclass from '@invideoio/web-shared/Modules/IVClass';
import Title from './Card/Title';
import { GuideContent } from './types';

import { getAppropriateUrl } from '@invideoio/web-shared/utils/common';

const Content = (props: GuideContent) => {
  const { index, heading, description, image, platform, browser } = props;

  const imageUrl = getAppropriateUrl(image.url, browser, platform);

  return (
    <div
      className={ivclass(
        'md:iv-grid lg:iv-grid',
        'md:iv-grid-cols-2 lg:iv-grid-cols-1',
        'md:iv-gap-25',
        'iv-h-full',
        'xl:iv-flex xl:iv-flex-col xl:iv-justify-between',
      )}
    >
      <div className={ivclass('sm:iv-pt-10')}>
        <div
          className={ivclass(
            'iv-flex',
            'iv-justify-center iv-items-center',
            'sm:iv-w-9 sm:iv-h-36 md:iv-w-10 md:iv-h-[40px] lg:iv-w-12 lg:iv-h-[48px] xl:iv-w-11 xl:iv-h-[44px]',
            'sm:iv-m-auto lg:iv-m-auto xl:iv-m-auto',
            'iv-text-center',
            'iv-rounded-full iv-border-2 iv-border-grey-0 iv-border-solid',
            'iv-body-3xl lg:iv-text-heading-3xs xl:iv-text-heading-3xs',
            'iv-font-medium',
          )}
        >
          {index}
        </div>
        <Title heading={heading} />
        <div
          className={ivclass(
            'sm:iv-pt-20 md:iv-pt-20 lg:iv-pt-25 xl:iv-pt-30',
            'sm:iv-m-body-xl md:iv-m-body-2xl lg:iv-m-body-2xl xl:iv-m-body-3xl',
            'sm:iv-text-center lg:iv-text-center xl:iv-text-center',
            'sm:iv-text-body-xl md:iv-text-body-2xl lg:iv-text-body-2xl xl:iv-text-body-3xl',
            'iv-font-medium',
          )}
        >
          {description}
        </div>
      </div>
      <div
        className={ivclass(
          'md:iv-place-self-center lg:iv-place-self-center',
          'iv-w-full',
        )}
      >
        <div
          className={ivclass(
            'iv-relative iv-flex iv-justify-center iv-w-full',
            'iv-h-[170px] sm:iv-h-[168px]',
            'sm:iv-mt-15 lg:iv-mt-30 xl:iv-mt-25',
          )}
        >
          <ImageComponent
            elementype="native"
            src={imageUrl}
            alt={image.alternativeText}
            className="iv-object-contain iv-h-full iv-w-full"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
};

export default Content;
